import initGlobalController from './animationsController';

export default function initAnimations() {
	initGlobalController();
};
